<template>
  <div class="queryOrder_page">
    <div class="container">
      <div class="row">
        <div class="queryOrder__topCon">
          <div class="queryOrder__topCon_line"></div>
          <span class="queryOrder_txtDarkBlue">船票订单查询</span>
          <div class="queryOrder__topCon_line"></div>
        </div>
        <div class="queryOrder__mainCon">
          <div class="queryOrder__mainCon_title" style="padding-bottom: 10px;">
            <p style=" height: 20px;">通过船票订单查询您可以：</p>
            <p style="font-size: 12px; height: 10px;">*可查看订单详情并进行在线支付</p>
            <p style="font-size: 12px; height: 10px;">*为已有订单预订岸上观光行程（仅限中国出发航线订单）</p>
            <p style="font-size: 12px; height: 10px;">*可将电话订单转为线上订单，在线查看详情并支付</p>
            <p style="font-size: 12px; height: 10px;">温馨提示：</p>
            <p style="font-size: 12px; height: 10px;">关联船票后，您可访问该订单下其他乘客的个人信息；办理在线登船手续；查看和修改订单信息；以及预订行前订产品</p>
          </div>
          <div class="cruise-switch-container">
            <div class="cruise-hp cruise-switch-wrapper active">
              <div class="cruise-switch">
                <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-selected.png">
              </div>
              <div class="cruise-switch-text">中国出发航线</div>
            </div>
            <div class="cruise-row cruise-switch-wrapper" @click="goToRow">
              <div class="cruise-switch">
                <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-unselected2.png">
              </div>
              <div class="cruise-switch-text">海外出发航线</div>
            </div>
          </div>
          <form id="queryOrder__form">
            <ul>
              <li class="">
                <div class="queryOrder__mainCon_input">
                  <p><span class="queryOrder__mainCon_red"> * </span>船票订单号：</p>
                  <input name="BookingId" class="queryOrder__mainCon_orderNum" v-model="bookingId" placeholder="不足7位请补0，例: 0012345">
                </div>
              </li>
              <li>
                <div class="queryOrder__mainCon_input">
                  <p><span class="queryOrder__mainCon_red"> * </span>姓（拼音）：</p>
                  <input name="LastName" 
                  placeholder="例如：LI" id="queryOrder__mainCon_lastName" 
                  :value="lastName" @input="inputValueUpper"
                  >
                </div>
                <p class="queryOrder__mainCon_liCare" id="lastNameInfo" style="color:#777;">该舱房任意乘客拼音（姓）</p>
              </li>

              <li>
                <div class="queryOrder__mainCon_input">
                  <p>
                    <span class="queryOrder__mainCon_red"> * </span>出生日期：</p>
                  <input name="DateOfBirth" class="queryOrder__mainCon_date" readonly="readonly" v-model="DateOfBirth"
                         @focus="isCalendarShowBir=true">
                </div>
                <p class="queryOrder__mainCon_liCare" id="lastNameInfo" style="color:#777;">上述乘客对应的出生日期</p>

                <RcclCalendar
                    class="guestInfo-calender"
                    v-if="isCalendarShowBir"
                    :allowPreYear="true"
                    :defaultDate="today"
                    v-on:onDateClicked="sailDateChangedBir"
                    :maxAge="100"
                />

              </li>

              <li>
                <div class="queryOrder__mainCon_input queryOrder__shipSelect" style="position:relative;">
                  <p><span class="queryOrder__mainCon_red"> * </span>所乘游轮：</p>
                  <select name="ShipCode" id="queryOrder__ship" v-model="shipCode">
<!--                    <option value="WN">海洋奇迹号</option>-->
                    <option value="SC">海洋光谱号</option>
                    <option value="OV">海洋赞礼号</option>
<!--                    <option value="QN">海洋量子号</option>-->
<!--                    <option value="VY">海洋航行者号</option>-->
                  </select>
                </div>
              </li>
              <li>
                <div class="queryOrder__mainCon_input">
                  <p>
                    <span class="queryOrder__mainCon_red"> * </span>出航日期：</p>
                  <input name="SailDate" class="queryOrder__mainCon_date" readonly="readonly" v-model="sailDate"
                         @focus="isCalendarShow=true">

                </div>
                <RcclCalendar
                    class="guestInfo-calender"
                    v-if="isCalendarShow"
                    :allowPreYear="false"
                    :defaultDate="today"
                    v-on:onDateClicked="sailDateChanged"
                    :maxYear="3"
                />

              </li>
            </ul>

            <!--二维码-->
            <div class="queryOrder__Wechat">
              <p>欢迎关注皇家加勒比官方微信公众号</p>
              <div class="queryOrder__WechatPic">
                <img src="https://resource.rcclchina.com.cn/bookingPay/Wechat.jpeg">
              </div>
            </div>
          </form>
          <p class="queryOrder__mainCon_attention">带<span class="queryOrder__mainCon_red">*</span>号的为必填</p>

          <div class="queryOrder__mainCon_submit" @click="submitBookingSearch">提交资料</div>
        </div>
      </div>
    </div>

    <LoginModal
        v-if="isShowLoginPopup"
        :onLoginSuccessHandler="onLoginSuccessHandler"
        :isShow="isShowLoginPopup"/>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/api'
import bookingHelper from '@/utilities/bookingHelper'

const LoginModal = () => import('@/components/User/LoginModal.vue')
const RcclCalendar = () => import('@/components/Common/RcclCalendar.vue')
export default {
  name: "BookingSearch",
  components: {
    LoginModal,
    RcclCalendar
  },
  data() {
    return {
      lastName: '',
      shipCode: 'SC',
      sailDate: '',
      bookingId: '',
      DateOfBirth: '',
      isShowLoginPopup: false,
      loginCallback: null,
      isCalendarShow: false,
      isCalendarShowBir: false,
    }
  },
  mounted() {
    const userToken = this.$store.state.user.userToken
    if (!userToken || userToken.length == 0) {
      this.goToLogin()
    }
  },
  methods: {
    // 强制小写转大写
    inputValueUpper(event) {
      this.lastName = event.target.value.toUpperCase();
    },
    async submitBookingSearch() {
      
      if (this.lastName.trim() == '') {
        this.$alert.show('请输入姓(拼音)')
        return
      } else if (!this.pyNameCheck(this.lastName)) {
        this.$alert.show('请输入正确的姓(拼音)')
        return
      }
      if (this.bookingId.trim() == '') {
        this.$alert.show('请输入订单号')
        return
      }
      if (this.sailDate.trim() == '') {
        this.$alert.show('请选择出航日期')
        return
      }
      if (this.DateOfBirth.trim() == '') {
        this.$alert.show('请选择上述乘客对应的出生日期')
        return
      }
      let bookingId = this.fixBookingId();
      const requestData = {
        bookingId: bookingId,
        lastName: this.lastName,
        sailDate: this.sailDate,
        DateOfBirth: this.DateOfBirth,
        shipCode: this.shipCode,
        agencyId: bookingHelper.agencyId
      }
      this.$loading.show()
      const {success, errMsg} = await api.booking.bookingSearch(requestData)
      this.$loading.hide()
      if (!success) {
        if (errMsg == 'USER_LOGIN_ERROR') {
          return this.goToLogin()
        }
        this.$alert.show(errMsg)
        return
      }
      this.$router.push({
        name: 'BookingDetail', query: {
          bookingId
        }
      })
    },
    fixBookingId () {
      if (!this.bookingId || this.bookingId.length == 0) {
        return '';
      }
      let bookingId = this.bookingId + '';
      if (bookingId.length >= 7) return bookingId;
      while (bookingId.length < 7) {
        bookingId = "0" + bookingId;
      }
      return bookingId;
    },
    goToLogin() {
      this.showLoginPopup()
    },
    goToRow() {
      location.href = this.rowSearchLink
    },
    pyNameCheck(pyName) {
      //中文验证
      if (!/^[A-Za-z]+$/.test(pyName)) {
        return false;
      }
      return true;
    },
    sailDateChangedBir(value) {
      if (value && value.length > 0) {
        this.DateOfBirth = value
      }
      this.isCalendarShowBir = false
    },
    sailDateChanged(value) {
      if (value && value.length > 0) {
        this.sailDate = value
      }
      this.isCalendarShow = false
    },
    showLoginPopup(callback) {
      this.isShowLoginPopup = true
      this.loginCallback = callback
    },
    onLoginSuccessHandler() {
      this.isShowLoginPopup = false
      if (this.loginCallback) {
        this.loginCallback()
        this.loginCallback = null
      }
    }
  },
  computed: {
    rowSearchLink() {
      return process.env.VUE_APP_BASE_URL + `/Rccl.Campaign/RedirectToTui?redirectUrl=${process.env.VUE_APP_TUI_URL}/Booking/BookingSearch`
    },
    today() {
      return moment().format('yyyy-MM-DD')
    }
    
  }
}
</script>

<style lang="less" scoped>
/* GLOBAL STYLES
-------------------------------------------------- */
/* Padding below the footer and lighter body text */
/* RESPONSIVE CSS
------------------------------------------------------------------------------------------------- */
/* common */
.queryOrder_page {
  background: #f0f0f0;
  padding-bottom: 250px;

  .calendar {
    left: 100px;
  }
}

.queryOrder_txtDarkBlue {
  font-size: 32px;
  color: #081259;
  font-weight: bold;
  height: 40px;
  line-height: 40px;
}

.queryOrder__mainCon_red {
  color: red;
}

.queryOrder__topCon {
  text-align: center;
  margin-top: 40px;
}

.queryOrder__topCon_line {
  width: 160px;
  height: 1px;
  border: 1px solid #fbc300;
  display: inline-block;
  vertical-align: middle;
}

.queryOrder__mainCon {
  background: #fff;
  margin-top: 28px;
  padding-left: 40px;
  padding-bottom: 40px;
}

.queryOrder__mainCon_title {
  font-size: 18px;
  padding-top: 30px;
}

.queryOrder__mainCon_title p {
  height: 40px;
  line-height: 20px;
}

.queryOrder__mainCon_attention {
  line-height: 20px;
}

.queryOrder__mainCon ul li {
  position: relative;
  width: 76%;
  height: 40px;
  line-height: 40px;
  margin: 20px 0px;
}

.queryOrder__mainCon_input {
  width: 60%;
  float: left;
  margin-left: 0;
  height: 90%;
  border: 2px solid #dedfe1;
  border-radius: 5px;
  overflow: hidden;
}

.queryOrder__mainCon_input p {
  line-height: 34px;
  height: 34px;
  text-align: right;
  margin-left: 5px;
  float: left;
  color: #777;
  font-weight: 900;
  font-size: 14px;
}

.queryOrder__mainCon_input input {
  float: right;
}

.queryOrder__mainCon_input input,
.queryOrder__mainCon_input select {
  width: 68%;
  color: #777;
  height: 25px;
  border: 0;
  line-height: 25px;
  font-size: 12px;
  margin: 6px 1%;
  outline: none;
}

.queryOrder__mainCon_liCare {
  margin-left: 10px;
  font-size: 12px;
  display: inline-block;
  margin-bottom: 0;
}

.queryOrder__shipSelect {

}


.queryOrder__mainCon_input select {
  border: none;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: none;
  /*padding-right: 32px;*/
  background: url("https://resource.rcclchina.com.cn/bookingPay/orderquery-select.png") no-repeat scroll right center transparent;
  cursor: pointer;
  margin-left: 36px;
}

.queryOrder__mainCon_input select option {
  padding: 4px;
}

.queryOrder__mainCon_input select::-ms-expand {
  display: none;
}

.queryOrder__mainCon_submit {
  width: 123px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  background: url("https://resource.rcclchina.com.cn/bookingPay/orderQuery-button.png") no-repeat;
  display: block;
  font-weight: 900;
  margin-left: 432px;
  color: #041555;
  cursor: pointer;
}

#sailDateCalendar {
  margin-left: 100px;
}


.login-remindTxt {
  margin-top: 22px;
  font-size: 13px;
}

.login-remindTxt span {
  color: #fcc400;
}

.loginPromot {
  margin-top: 10px;
  font-size: 13px;
}

.sin_container {
  margin-top: 10px;
  font-size: 12px;
}

.sin_container a {
  color: #edb000;
}

.sin_container span {
  vertical-align: middle;
  color: #000;
  font-size: 13px;
}


/*新增样式*/
#queryOrder__form {
  position: relative;
}

/*二维码样式*/
.queryOrder__Wechat {
  position: absolute;
  top: 10px;
  right: 40px;
}

.queryOrder__Wechat p {
  color: #777;
  font-weight: 900;
  font-size: 14px;
}

.queryOrder__WechatPic {
  width: 172px;
  height: 172px;
  margin: 0 auto;
}

.queryOrder__WechatPic img {
  width: 100%;
}

ul.dropdown-menu li {
  margin: 0px;
}

#queryOrder__ship {
  float: right;
}

/**** 隐私政策 ****/
.sin_container .input__top img {
  width: 17px;
  height: 17px;
  cursor: pointer;
}

.sin_container .input__top.isAgreePushMsg img:nth-child(1) {
  display: none;
}

.sin_container .input__top.isAgreePushMsg img:nth-child(2) {
  display: inline-block;
}

.sin_container .input__top.isAgreePushMsg.active img:nth-child(1) {
  display: inline-block;
}

.sin_container .input__top.isAgreePushMsg.active img:nth-child(2) {
  display: none;
}

.sin_container .input__top.isAgreePrivacy img:nth-child(1) {
  display: none;
}

.sin_container .input__top.isAgreePrivacy img:nth-child(2) {
  display: inline-block;
}

.sin_container .input__top.isAgreePrivacy.active img:nth-child(1) {
  display: inline-block;
}

.sin_container .input__top.isAgreePrivacy.active img:nth-child(2) {
  display: none;
}


/**航线切换**/
.cruise-switch-container {
  .cruise-switch-text {
    margin-left: 5px;
  }
}

.cruise-switch-container .cruise-switch-wrapper {
  display: inline-block;
  vertical-align: middle;
  font-size: 18px;
  cursor: pointer;
}

.cruise-switch-container .cruise-switch-wrapper > div {
  display: inline-block;
  vertical-align: middle;
}

.cruise-switch-container .cruise-switch-wrapper .cruise-switch {
  width: 15px;
}

.cruise-switch-container .cruise-switch-wrapper .cruise-switch img {
  width: 100%;
}

.cruise-switch-container .cruise-row {
  margin-left: 30px;
}

.groupType-select {
  color: #777;
  font-weight: 900;
  font-size: 14px;
  display: inline-block;
}

.btn-group .dropdown-menu li {
  width: 100%;
  cursor: pointer;
}

</style>
